import { environment } from 'src/environments/environment';
export type DataGridSearchByColumns = 'SearchParam' | 'DateFrom' | 'DateTo' | 'SelectionId' | 'SecondSelectionId';
export type PageSizes = '5' | '15' | '10' | '20' | '30' | '50' | '100';

export class GlobalConstants {
    static apiBaseUrl = environment.apiUrl;
    static serverDomain = environment.serverDomain;
    static DataGridStateLsKey = 'DataGridState';
}